import axios from 'axios'

class VolleyballApi {
  constructor ($env) {
    this.$env = $env
  }

  setFederationCode (federationCode) {
    this.federationCode = federationCode
    return this
  }

  setAuthToken (authToken) {
    this.authToken = authToken
    return this
  }

  getMatchList () {
    return this.getResource('MatchList')
  }

  getMatchLiveData (fedMatchID) {
    return this.getResource('MatchLiveData/FedMatchID/' + fedMatchID)
  }

  getMatchFullInfo (fedMatchID) {
    return this.getResource('MatchLiveFullInfo/FedMatchID/' + fedMatchID)
  }

  getRoster (fedMatchID) {
    console.log('getRoster', fedMatchID)
    return this.getResource('Roster/FedMatchID/' + fedMatchID)
  }

  getResource (resource) {
    // eslint-disable-next-line
    return new axios.create({
      headers: {
        'Authorization': this.authToken
      }
    }).get(this.getUrl(resource))
  }

  getUrl (resource) {
    if (this.$env.NODE_ENV === 'development') {
      return '/static/volleyball-webapi/' + resource.replace(/\//g, '-') + '.json'
    }
    const endpoint = 'https://dataprojectserviceswebapilive.azurewebsites.net/api/v1/'
    return (endpoint + '/').slice(0, -1) + this.federationCode + '/' + resource
  }
}

export default VolleyballApi



// WEBPACK FOOTER //
// ./src/api/VolleyballApi.js